import React, { forwardRef } from 'react';
import { css, cx } from '@linaria/atomic';
import type { CommonHTMLButtonAttributes } from '@frontend/types';
import { theme } from '@frontend/theme';
import { NakedButton } from '../../../naked/naked-button.component';
import { truncate } from '../common-styles';

const chipStyleAliasStyle1 = css`
  display: flex;
  width: var(--chip-width);
  min-width: var(--chip-min-width);
  max-width: var(--chip-max-width);
  height: 24px;
  font-weight: ${theme.font.weight.regular};
  font-size: ${theme.font.size.small};
  text-align: left;
  justify-content: space-between;
  align-items: center;
  border-radius: ${theme.borderRadius.small};
  background-color: ${theme.colors.white};
  padding: ${theme.spacing(0, 1)};
  gap: ${theme.spacing(0.5)};
`;

const chipActiveStyle = css`
  font-weight: ${theme.font.weight.bold};
  background-color: ${theme.colors.neutral10};
`;

const chipStyleAliasStyle2 = css`
  box-shadow: ${theme.shadows.floating};
`;

const chipStyleAliasStyle3 = css`
  cursor: initial;
  svg {
    opacity: 0.8;
  }
`;

const chipStyleAliasStyle4 = css`
  &:hover {
    background-color: ${theme.colors.neutral10};
  }
`;

const componentSpanStyle5 = css`
  display: flex;
  align-items: center;
`;

const componentSpanStyle6 = css`
  display: flex;
  align-items: center;
`;

const componentSpanStyle7 = css`
  display: flex;
  align-items: center;
`;

export type ActionPressedChipProps = CommonHTMLButtonAttributes & {
  children: React.ReactNode;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  isActive?: boolean;
  disabled?: boolean;
  hasPopover?: boolean;
  compact?: boolean;
  width?: string;
  minWidth?: string;
  maxWidth?: string;
  showBoxShadow?: boolean;
};

export const ActionPressedChip = forwardRef<HTMLButtonElement, ActionPressedChipProps>(
  (
    { children, startIcon, endIcon, isActive, disabled, compact, width, minWidth, maxWidth, showBoxShadow, ...rest },
    ref
  ) => {
    return (
      <NakedButton
        ref={ref}
        disabled={disabled}
        {...rest}
        style={
          {
            '--chip-width': compact ? 'auto' : width || '102px',
            '--chip-min-width': minWidth || 'none',
            '--chip-max-width': maxWidth || 'none',
          } as any
        }
        className={cx(
          chipStyleAliasStyle1,
          isActive && chipActiveStyle,
          showBoxShadow && chipStyleAliasStyle2,
          disabled ? chipStyleAliasStyle3 : chipStyleAliasStyle4,
          rest.className
        )}
      >
        {startIcon && <span className={componentSpanStyle5}>{startIcon}</span>}
        <span className={cx(truncate, componentSpanStyle6)}>{children}</span>
        {endIcon && <span className={componentSpanStyle7}>{endIcon}</span>}
      </NakedButton>
    );
  }
);
ActionPressedChip.displayName = 'ActionPressedChip';
